import { merge } from 'lodash/object';
import externals from 'webpack-node-externals';

import generateConfig, { cwd } from './generateConfig';
import jsRule, { TARGET_NODE_6 } from './rules/js';
import ignoreRule, { SCSS_PATTERN } from './rules/ignore';

export const ENTRY_FILE = './index.jsx';
export const MODULES_DIR = cwd('node_modules');

export default ({ entry, outputDir = 'bin', mode = process.env.NODE_ENV }) => {
  const defaultConfig = generateConfig({ entry, outputDir, mode });

  return merge(defaultConfig, {
    target: 'node',

    module: {
      rules: [
        jsRule(TARGET_NODE_6),
        ignoreRule(SCSS_PATTERN),
      ],
    },

    externals: [
      externals({
        modulesdir: MODULES_DIR,
      }),
    ],

    node: {
      console: false,
      global: false,
      process: false,
      Buffer: false,
      setImmediate: false,
    },

    output: {
      path: cwd(outputDir),
      filename: '[name].js',
      sourceMapFilename: '[file].map',
      chunkFilename: '[id]-[chunkhash].js',
      libraryTarget: 'commonjs',
    },
  });
};
